<!--发起调拨页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>

      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">发&nbsp;&nbsp;货&nbsp;&nbsp;仓：</td>
          <td width="180">
            <el-select v-model="cangkucode" placeholder="请选择" size="mini" @change="changesend">
              <el-option
                v-for="item in jxcstoreDatasend"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;址：</td>
          <td>{{addresssend!=null?addresssend:""}}</td>
          <td align="right" width="60">电&nbsp;&nbsp;&nbsp;话：</td>
          <td width="140">{{linktelsend!=null ?linktelsend:" "}}
          </td>
        </tr>

        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">收&nbsp;&nbsp;货&nbsp;&nbsp;仓：</td>
          <td width="140">
            <el-select v-model="cangkucode2" placeholder="请选择" size="mini" @change="changereceive">
              <el-option
                v-for="item in jxcstoreDatareceive"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;址：</td>
          <td width="220">{{addressreceive!=null?addressreceive:""}}</td>
          <td align="right" width="60">电&nbsp;&nbsp;&nbsp;话：</td>
          <td width="140">{{linktelreceive!=null ? linktelreceive:" "}}
          </td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">商&nbsp;&nbsp;品&nbsp;&nbsp;名：</td>
          <td colspan="2">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :isShowCheckBox="false" :treeWidth="600"
                        :treeHeight="400" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
          <td>
          </td>
          <td align="right">时&nbsp;&nbsp;&nbsp;间:</td>
          <td>
          </td>
        </tr>
        <tr class="noborder" style="height: 26px;display: none" v-if="false">
          <td align="right">物&nbsp;&nbsp;&nbsp;流：</td>
          <td>
            <el-select v-model="logisticsco" placeholder="请选择" size="mini">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </td>
          <td align="right">单&nbsp;&nbsp;&nbsp;号：</td>
          <td>
            <el-input v-model="logisticsnum" auto-complete="off" required="true" size="mini"
                      style="width: 180px;" placeholder="请填写发货单号"></el-input>
          </td>
        </tr>
        <tr >
          <td colspan="6" style="text-align: right">总数:{{totalnumber}}</td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
            <el-table
              :data="tableData"
              :height="tableHeight(300)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="seedname" :show-overflow-tooltip="true"
                label="名称"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" v-if="isyinxin"
                label="注册证号"
                align="left" width="160"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.certno}}
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" v-if="isyinxin"
                               label="失效日期"
                               align="left"  width="100"
                               header-align="center">
                <template slot-scope="scope">
                  {{scope.row.endtime}}
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" v-if="isyinxin"
                label="批次号"
                align="left" width="130"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.batchno}}
                </template>
              </el-table-column>
              <el-table-column
                prop="P"
                label="库存"
                align="center"
                width="70"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.P}}
                </template>
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event)"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event)"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event)"
                            @change="totalNumber"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="6">
            <textarea style="width: 100%;height: 60px" v-model="remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading" v-if="lock">{{buttonname}}</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getJxcformdetailCost} from '@/api/set/csagreement';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getPrice} from '@/api/set/goodsprice';
  import {getGoodsNeedBuy, getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {getDetail} from '@/api/set/allocation';
  import {getDetail as barcodeDetail,batchSave} from '@/api/set/jxcstoregoodsbarcode';
  import {getListData} from '@/api/set/jxcstore'
  import {getListDatabyinpd, getListDataall} from '@/api/set/jxcstore';
  import {saveData} from '@/api/set/allocation';
  import {getParameterDetail} from '@/api/set/parameter';
  import {lockremove} from '@/api/set/handlelog';
  import {getListData as listCert} from '@/api/set/certmanage'

  export default {
    name: 'AllocationEdit40',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        buttonname: '',
        userInfoModel: {},
        loading: false,
        dialogFormVisible: false,
        title: "",
        index: -99,
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        minyear: yearnow,
        minmonth: monthnow,
        maxyear: '',
        maxmonth: '',
        remark: '',
        cangkucodes: [],
        unitguid: '',
        jxcstoreDatareceive: [],
        jxcstoreDatasend: [],
        cangkucode: '',
        cangkuname: '',
        cangkucode2: '',
        cangkuname2: '',
        addresssend: '',
        linktelsend: '',
        addressreceive: '',
        linktelreceive: '',
        tableData1: [],
        tableData: [],//镜架使用
        column: [],
        filltemplate: '',
        controlData: '',
        showtitle1: "none",
        logisticsco: '',
        logisticsnum: '',
        seedinfo: '',
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          erpserial: "",
        },
        isupdate: false,
        isyinxin:false,
        updatecz: 0,
        parameterData: [],
        categorycode: '',
        storeinfo: [],//仓库信息
        storenumber:[],//库存数量
        independentserial: '',//仓库对应的核算部门
        lock: true,//锁定订单
        uname: '',//正在操作的人
        totalnumber: 0,//镜架 调拨总数
      }

    },
    methods: {
      checkCanSelect() {
        if (this.cangkucode == this.cangkucode2) {
          this.error('发货仓、收货仓不能选同一个！')
          return false;
        }
        return true;
      },
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
        this.loading = false;
      },
      //回车跳入下一行
      validateCounts(row, index, e) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[Object.keys(this.$refs)[index + 1]].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[Object.keys(this.$refs)[index - 1]].focus();
        }
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      //绑定库存
      bindStore(needAddRow,needadd) {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1

        getGoodsListWithStoreDetail({
          seedcode: needAddRow.seedcode,//
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          nolimit: 1,
          nodeliverying: 1,
          nobuynum: 1,
          cangkucode: this.cangkucode,
          calculateStore: "1",
          showyinxing: "2"
        }).then(resStore => {

          var barcodeseed=resStore.data.barcodeseed;
          var barcode=resStore.data.barcode;
          for (let j in barcodeseed) {
            if (barcodeseed[j] == needAddRow.seedcode) {
              this.isyinxin=true;
              needAddRow.yinxin = true;
              break;
            }
          }
          if(needadd) {
            if (needAddRow.yinxin) {
              //根据匹次号插入
              for (let m in barcode) {
                var newRow = JSON.parse(JSON.stringify(needAddRow));
                newRow.batchno = barcode[m].batchno;
                newRow.certno = barcode[m].certno;
                newRow.certorg = barcode[m].certorg;
                newRow.endtime = this.getShortTime(barcode[m].endtime);
                newRow.P = barcode[m].totalnumber;
                newRow.barcode = barcode[m].unitguid;
                // newRow.barcode.push(barcode[m]);
                newRow.yinxin = true;
                newRow.totalnumber=undefined;
                this.tableData.push(newRow);
              }
            } else {//非隐形商品
              var KucNum = 0;
              for (let i in resStore.data.obj) {
                KucNum += (resStore.data.obj[i].subtractnum ? resStore.data.obj[i].subtractnum : 0);
              }
              needAddRow.P = KucNum;
              this.tableData.push(needAddRow);
            }
          }else{
            if (needAddRow.yinxin) {
              for (let m in barcode) {
                console.log(barcode[m])
                for(let i in this.tableData){
                  var newRow=this.tableData[i];
                  console.log(newRow)
                  if(newRow.barcode==barcode[m].unitguid){
                    console.log('begin')
                    newRow.P= barcode[m].totalnumber;
                    newRow.batchno = barcode[m].batchno;
                    newRow.certno = barcode[m].certno;
                    newRow.certorg = barcode[m].certorg;
                    newRow.endtime = this.getShortTime(barcode[m].endtime);
                    newRow.yinxin = true;
                    break;
                  }
                }
              }
            }else{
              var KucNum = 0;
              for (let i in resStore.data.obj) {
                KucNum += (resStore.data.obj[i].subtractnum ? resStore.data.obj[i].subtractnum : 0);
              }
              needAddRow.P = KucNum;
              for(let i in this.tableData){
                if(this.tableData[i].seedcode==needAddRow.seedcode){
                  this.tableData[i].P=KucNum;
                }
              }
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      getShortTime(stime){
        if(!stime) return '';
        var tt=new Date(stime);
        return tt.getFullYear()+"-"+this.getPad0(tt.getMonth()+1)+"-"+this.getPad0(tt.getDate());
      },
      getPad0(num){
        if(num<10) return '0'+num;
        return num;
      },
      getBarcode(row,column) {
        if (!row.yinxin || !row.barcode)
          return '';
        for (let i in row.baritem) {
          if (row.baritem[i].unitguid == row.barcode)
            if (column == 'endtime') {
              return row.baritem[i][column].split(' ')[0];
            }
          return row.baritem[i][column];
        }
        return '';
      },
      getTitle() {
        return this.userInfoModel.tenantname + "调拨单";
      },
      checktree1(guids, names, arr) {
        if (!guids) return;

        if (this.checkCanSelect()) {
          this.form.seedcode = guids
          this.form.seedname = names
          this.filltemplate = arr[0].attributes.filltemplate
          this.categorycode = arr[0].parentId;
          for(let i in this.tableData) {
            if (this.tableData[i].seedcode == guids) {//已经有的不再加载
              return;
            }
          }
          this.bindStore({
            seedcode: guids,
            seedname: names,
            categorycode: arr[0].parentId,
            P: 0,
            totalnumber: null,
            formproperty: '[{}]',
            yinxin: false,
            barcode: '',
            baritem: '',
          },true);
        }

        this.$refs.treeSeed.reset();
        this.form.seedcode = ''
        this.form.seedname = ''
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1,filltemplates:'40'})
        })
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          var num = (this.tableData[i].totalnumber && this.tableData[i].totalnumber != undefined) ? parseInt(this.tableData[i].totalnumber) : 0;
          this.totalnumber = this.totalnumber + num
        }
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)

          this.showtitle1 = "none"
        })
      },
      show(item) {
        this.dialogSeeVisible = true;
      },
      changesend(val) {
        this.tableData=[];//发货仓 重新选择后，商品清空
        for (let i in this.jxcstoreDatasend) {
          if (this.jxcstoreDatasend[i].cangkucode == val) {
            this.cangkuname = this.jxcstoreDatasend[i].cangkuname;
            this.addresssend = this.jxcstoreDatasend[i].address
            this.linktelsend = this.jxcstoreDatasend[i].tel
            this.independentserial = this.jxcstoreDatasend[i].independentserial
            this.storenumber = []//仓库更换后需要重新计算库存
          }
        }
      },
      changereceive(val) {
        for (let i in this.jxcstoreDatareceive) {
          if (this.jxcstoreDatareceive[i].cangkucode == val) {
            this.cangkuname2 = this.jxcstoreDatareceive[i].cangkuname
            this.addressreceive = this.jxcstoreDatareceive[i].address
            this.linktelreceive = this.jxcstoreDatareceive[i].tel
          }
        }
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      errorMessag(msg) {
        this.$message({
          message: msg,
          type: 'warning'
        })
        this.loading = false;
      },
      saveData() {
        //取出对应的表单详情和数量
        var arr = [];
        for (let i in this.tableData) {
          var obj = {}
          obj.seedcode = this.tableData[i].seedcode
          obj.seedname = this.tableData[i].seedname
          obj.categorycode = this.tableData[i].categorycode
          obj.barcodes = this.tableData[i].yinxin ? this.tableData[i].barcode : '';

          // if (this.tableData[i].yinxin) {
          //   isyinxin = true;
          //   if (!obj.barcodes) {
          //     this.errorMessag(obj.seedname + '：必须选批次号！')
          //     return
          //   }
          // }
          //
          // for (let j in arr) {
          //   if (arr[j].seedcode == obj.seedcode && arr[j].barcodes == obj.barcodes) {
          //     this.errorMessag(obj.seedname+'：重复增加，请核对！')
          //     return
          //   }
          // }

          if (this.tableData[i].totalnumber && this.tableData[i].totalnumber != undefined && parseInt(this.tableData[i].totalnumber) > 0) {
            if (this.isyinxin) {
              if (!obj.barcodes) {
                this.errorMessag(obj.seedname + '：必须选批次号！')
                return;
              }
            }
            obj.P = this.tableData[i].totalnumber
            arr.push(obj)
          } else {
            // this.errorMessag('调拨数量必须填写！')
            // return
          }
        }

        if (arr.length == 0) {
          this.errorMessag('请填写调拨数量！')
          return
        }
        if (!this.cangkucode) {
          this.errorMessag('请选择发货仓库！')
          return
        }
        if (!this.cangkucode2) {
          this.errorMessag('请选择收货仓库！')
          return
        }

        if (this.cangkucode == this.cangkucode2) {
          this.errorMessag('发货仓库、收货仓库不能相同！')
          return
        }
        if (arr.length != 0) {
          let jxcformdetails = [];
          for (let i in arr) {
            jxcformdetails.push(
              {
                seedcode: arr[i].seedcode,
                seedname: arr[i].seedname,
                categorycode: '',
                packagesize: '',
                totalnumber: arr[i]["P"],
                barcodes: arr[i].barcodes,
              }
            )
          }
          saveData({
            unitguid: this.unitguid,
            seedgoods: JSON.stringify(jxcformdetails),
            cangkucode: this.cangkucode,
            cangkuname: this.cangkuname,
            cangkucode2: this.cangkucode2,
            cangkuname2: this.cangkuname2,
            remark: this.remark,
            seedcode: arr[0].seedcode,
            seedname: arr[0].seedname,
            updatecz: this.updatecz,
            logisticsco: this.logisticsco,
            logisticsnum: this.logisticsnum,
            seedinfo: '其他商品',
            categorycode: this.categorycode,
            erpserial: this.form.erpserial,
            filltemplate: "40",
            casestatus: this.isyinxin ? 100 : 0
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功，等待' + this.cangkuname + '发货。',
                type: 'success'
              })
              this.$emit('bindGrid', this.buttonname == '通过');
            } else {
              this.errorMessag(response.data.msg)
            }
            this.dialogSeeVisible = false;
            //刷新列表
          });
          //

        } else {
          this.errorMessag('请填写调拨单明细！')
        }
      }
      ,
      initData(item, isupdate, filltemplate) {
        this.initForm()
        //通过isupdate判读是否是进行修改的操作
        if (isupdate && isupdate == 1) {
          this.isupdate = true
          this.updatecz = 1
          this.unitguid = item.unitguid
          getDetail({unitguid: item.unitguid}).then(response => {
            if (response.data.obj.tenantid != this.userInfoModel.tenantid) {//不是本门店的订单，需要修改
              response.data.obj.cangkucode = response.data.obj.tenantid + '@' + response.data.obj.cangkucode;
              response.data.obj.cangkucode2 = response.data.obj.cangkucode2.split('@')[1];
            }
            this.controlData = response.data.obj;
            if (this.controlData.status == -20 && !this.userInfoModel.independentserial) {//总部订单岗审核
              this.buttonname = '通过'
            }
            this.form.erpserial = response.data.obj.erpserial;
            // this.form.seedcode = this.controlData.seedcode
            // this.form.seedname = this.controlData.seedname
            var seedcodes = [];
            for (let i in this.controlData.seedgooddlist) {
              var row = this.controlData.seedgooddlist[i];
              var barcode = null;
              if (row.barcodes) {
                barcode = JSON.parse(row.barcodes).storegoodsbarcode;
              }
              this.tableData.push({
                seedcode: row.seedcode,
                seedname: row.seedname,
                categorycode: this.controlData.seedcode,
                totalnumber: row.totalnumber,
                formproperty: '[{}]',
                unitguid: row.unitguid,
                barcode: barcode,
                yinxin: false,
                erpserial: row.erpserial,
                batchno: '',
                certno: '',
                endtime: '',
                P: null,
              })
              if (seedcodes.indexOf(row.seedcode) == -1) {
                seedcodes.push(row.seedcode);
              }
            }
            this.totalNumber()

            getListDataall({showother: 1}).then(response => {
              this.jxcstoreDatasend = response.data.obj
              for (let i in this.jxcstoreDatasend) {
                if (this.jxcstoreDatasend[i].independentserial = this.controlData.cangkucode) {
                  this.independentserial = this.jxcstoreDatasend[i].independentserial
                }
              }

              this.cangkucode = this.controlData.cangkucode
              this.cangkuname = this.controlData.cangkuname

              this.jxcstoreDatareceive = response.data.obj
              this.cangkucode2 = this.controlData.cangkucode2
              this.cangkuname2 = this.controlData.cangkuname2

              this.storenumber = []//仓库更换后需要重新计算库存
              for (let j in seedcodes) {
                this.bindStore({seedcode: seedcodes[j]}, false);
              }
            })
            this.remark = JSON.parse(this.controlData.remark)[0].msg
          });
        }else {
          getListDataall({showother:1}).then(response => {
            this.jxcstoreDatasend = response.data.obj
            this.independentserial = this.jxcstoreDatasend[0].independentserial
            this.cangkucode = this.jxcstoreDatasend[0].cangkucode
            this.cangkuname = this.jxcstoreDatasend[0].cangkuname
            this.addresssend = this.jxcstoreDatasend[0].address
            this.linktelsend = this.jxcstoreDatasend[0].tel

            this.jxcstoreDatareceive = response.data.obj

            var storeInfo = this.jxcstoreDatareceive[0];
            if (this.userInfoModel.independentserial) {
              for (let i in this.jxcstoreDatareceive) {
                if (this.jxcstoreDatareceive[i].independentserial == this.userInfoModel.independentserial) {
                  storeInfo = this.jxcstoreDatareceive[i];
                  break;
                }
              }
            }
            this.cangkucode2 = storeInfo.cangkucode
            this.cangkuname2 = storeInfo.cangkuname
            this.addressreceive = storeInfo.address
            this.linktelreceive = storeInfo.tel
          })
        }
      },
      initForm() {
        this.loading = false;
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.buttonname = '保存'
        this.form.seedcode = ""
        this.storenumber=[]
        this.form.seedname = ''
        this.tableData1 = []
        this.remark = ''
        this.filltemplate = ''
        this.cangkucode = ''
        this.cangkuname = ''
        this.cangkucode2 = ''
        this.cangkuname2 = ''
        this.isupdate = false
        this.updatecz = 0
        this.seedinfo = ''
        this.logisticsco = ''
        this.categorycode = ''
        this.storeinfo = []
        this.uname = ''
        this.lock = true
        this.tableData = []
        this.totalnumber = 0
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
    },
    components: {
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/warehouse/AllocationEdit40.vue